var _excluded = ["value", "onBlur", "onChange", "readOnly", "minDate", "maxDate"];
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from 'react';
import { DateInput } from 'semantic-ui-calendar-react';
import { FormInput, Popup } from "../..";
import "./Date.css";
import { jsx as _jsx } from "react/jsx-runtime";
/**
* @deprecated  Veuillez utiliser SingleDatePicker ou DateRangePicker à la place.
*/
var DateJvs = function DateJvs(props) {
  var value = props.value,
    onBlur = props.onBlur,
    onChange = props.onChange,
    readOnly = props.readOnly,
    minDate = props.minDate,
    maxDate = props.maxDate,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var _React$useState = React.useState(value || ''),
    date = _React$useState[0],
    setDate = _React$useState[1];
  var _React$useState2 = React.useState(false),
    open = _React$useState2[0],
    setOpen = _React$useState2[1];
  var handleInputBlur = React.useCallback(function (event) {
    var _ref = event || {},
      target = _ref.target;
    // eslint-disable-next-line @typescript-eslint/no-shadow
    var _ref2 = target || {},
      value = _ref2.value,
      valueAsDate = _ref2.valueAsDate;
    setDate(value);
    setOpen(false);
    if (value) {
      onBlur == null || onBlur(event, Object.assign({
        type: 'date'
      }, props, {
        value: value,
        valueAsDate: valueAsDate
      }));
    }
  }, [onBlur, props]);
  var handleInputChange = React.useCallback(function (event) {
    var _ref3 = event || {},
      target = _ref3.target;
    // eslint-disable-next-line @typescript-eslint/no-shadow
    var _ref4 = target || {},
      value = _ref4.value,
      valueAsDate = _ref4.valueAsDate;
    setDate(value);
    if (value) {
      onChange == null || onChange(event, Object.assign({
        type: 'date'
      }, props, {
        value: value,
        valueAsDate: valueAsDate
      }));
    }
  }, [onChange, props]);
  var handleCalendarChange = React.useCallback(function (event, data) {
    var _ref5 = data || {},
      valueDate = _ref5.value;
    var calendarDate = new Date(valueDate);
    setDate(valueDate);
    setOpen(false);
    onBlur == null || onBlur(event, Object.assign({
      type: 'date'
    }, props, {
      value: valueDate,
      valueAsDate: calendarDate
    }));
  }, [onBlur, props]);
  var handleCalendarClose = React.useCallback(function () {
    setOpen(false);
  }, [setOpen]);
  var handleCalendarClick = React.useCallback(function () {
    setOpen(!open);
  }, [open]);
  var preventDefaultPickerOpen = React.useCallback(function (event) {
    // Sans cela, si on appuie sur la barre espace, le picker par défaut du navigateur s'ouvre
    if (event.key === ' ') {
      event.preventDefault();
    }
  }, []);
  React.useEffect(function () {
    setDate(value || '');
  }, [value]);
  return React.useMemo(function () {
    return /*#__PURE__*/_jsx(Popup, {
      open: open,
      trigger: /*#__PURE__*/_jsx("div", {
        className: "dateForm",
        children: /*#__PURE__*/_jsx(FormInput, Object.assign({}, rest, {
          type: "date"
        }, !readOnly ? {
          icon: {
            name: 'calendar alternate outline',
            onClick: handleCalendarClick,
            link: true
          }
        } : {}, {
          input: {
            onKeyDown: preventDefaultPickerOpen
          },
          value: date,
          min: minDate,
          max: maxDate,
          onChange: handleInputChange,
          onBlur: handleInputBlur
        }))
      }),
      onClose: handleCalendarClose,
      position: "bottom right",
      popperModifiers: [{
        preventOverflow: {
          boundariesElement: 'window'
        }
      }],
      on: "click",
      flowing: true,
      hoverable: true,
      style: {
        padding: 0
      },
      children: /*#__PURE__*/_jsx(DateInput, {
        value: date,
        onChange: handleCalendarChange,
        dateFormat: "YYYY-MM-DD",
        animation: undefined,
        duration: 0,
        localization: "fr",
        icon: "calendar alternate outline",
        initialDate: date,
        closeOnMouseLeave: false,
        style: {
          width: '150px'
        },
        inline: true,
        minDate: minDate,
        maxDate: maxDate
      })
    });
  }, [open, maxDate, minDate, rest, date, readOnly, handleCalendarClick, handleInputChange, handleInputBlur, handleCalendarClose, handleCalendarChange, preventDefaultPickerOpen]);
};
DateJvs.handledProps = ["readOnly"];
DateJvs.defaultProps = {
  readOnly: false
};
export default DateJvs;